<script lang="ts">
  import type { FeatureTracking } from "../FeatureTracking";
  import type { FacetValue } from "../FacetValue";
  import { addTrackingAttributes } from "../Tracking";

  export let elementId: string;
  export let parentId: string | undefined;
  export let position: string | undefined;
  export let facetName: string | undefined;
  export let activeValue: FacetValue;
  export let featureTracking: FeatureTracking | undefined = undefined;

  /*                     */
  if (featureTracking) {
    featureTracking.method = "switch";
    featureTracking.parentId = parentId;
    featureTracking.position = position;
    /*        */
    if (!activeValue.selected) {
      featureTracking.status = undefined;
    }
  }
</script>

<oc-switch-v2
  size="100"
  oc-aria-label="Wähle den Filterwert {activeValue.displayName} aus"
  id={elementId}
  class="js_tValue find_facetValue--switch"
  type="checkbox"
  name={facetName}
  value={activeValue.id}
  checked={activeValue.selected ? true : undefined}
  data-ts-feature-filter-method="switch"
  label-placement="left"
  use:addTrackingAttributes={featureTracking}
>
  <label
    for={elementId}
    class="pl_switch__label find_facetValue__label find_facetValue"
    data-count={activeValue.itemCount}
  >
    <span class="oc-copy-100 oc-copy--bold">{activeValue.displayName}</span>
  </label>
</oc-switch-v2>
